import { gql } from '@apollo/client';

const ENDPOINT = {
    GET_SUBSCRIPTION_ID_AND_CONTACT: gql`
        query getMySubscriptionsAndContactDetails {
            getMySubscriptions {
                content {
                    id
                    accountId
                    type
                    catalogOfferCode
                    serviceGroup
                    dependsOn
                    terminatedAt
                }
            }
            getMyContactDetails {
                #createdAt
                #idLastCheckedAt
                #gdprValidatedAt
                #gdprLanguage
                #communicationPreference
                #allowThirdParties
                uuid
                #identityDocuments
                addresses {
                    addressLine1
                    addressLine2
                    addressLine3
                    town
                    county
                    eircode
                    code
                    type
                }
                #title
                firstName
                lastName
                #birthDate
                phoneNumbers {
                    phoneNumber
                    type
                    id
                }
                emails {
                    email
                }
            }
        }
    `,
    GET_AUTHORISED_USER: gql`
        query getMyAuthorizedUser($accountId: String!) {
            getMyAuthorizedUsers(accountId: $accountId) {
                firstName
                lastName
            }
        }
    `,
    GET_MY_PAYMENT_METHOD_DETAILS: gql`
        query getPaymentMethod($account_id: String!) {
            getPaymentMethod(account_id: $account_id) {
                accountId
                brand
                payerContactUuid
                payerRef
                paymentMethods {
                    canceled
                    canceledAt
                    default
                    expirationDate
                    partialDigits
                    paymentMethodId
                    paymentMethodType
                    status
                    providerReference
                    type
                    iban
                }
            }
        }
    `,

    GET_MY_CONTRACTS: gql`
        query getContracts($subscriptionId: Int!) {
            getMyServiceContract(subscriptionId: $subscriptionId) {
                id
                startAt
                endedAt
            }
        }
    `,
};
export const getMySubscriptionsAndContactDetailsApi = async ({ graphql }) => {
    try {
        const response = await graphql.query({
            query: ENDPOINT.GET_SUBSCRIPTION_ID_AND_CONTACT,
        });

        return response;
    } catch (error) {
        throw new Error(error);
    }
};
export const getMyAuthorizedUserApi = async ({ graphql, token, accountId }) => {
    try {
        const response = await graphql.query({
            query: ENDPOINT.GET_AUTHORISED_USER,
            variables: {
                accountId: accountId,
            },
        });
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
export const getPaymentMethodApi = async ({ graphql }) => {
    try {
        const response = await graphql.query({
            query: ENDPOINT.GET_MY_PAYMENT_METHOD_DETAILS,
            variables: {
                account_id: sessionStorage.getItem('LoggedinUserAccountID'),
            },
        });
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
export const getContractsApi = async ({ graphql, subscriptionId }) => {
    try {
        const response = await graphql.query({
            query: ENDPOINT.GET_MY_CONTRACTS,
            variables: {
                subscriptionId: parseInt(subscriptionId),
            },
        });
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
